import * as svg from "../../../assets/close-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const CloseIcon = iconBuilder(svg, "CloseIcon", "0 0 14 14");
